<template>
  <ul class="nav-bar">
    <li class="home" :class="{'qyg-liWidth': isInQYGChannel}">
      <router-link :to="qygHomeHref" :class="{active: activeTab === qygHomeHref}" v-if="isInQYGChannel">
        <icon size="28" :color="activeTab === qygHomeHref ? activeColor : ''">tab_shouye</icon>
        <span>首页</span>
      </router-link>
      <router-link to="/" :class="{active: activeTab === '/'}" v-else>
        <icon size="28" :color="activeTab === '/' ? activeColor : ''">tab_shouye</icon>
        <span>首页</span>
      </router-link>
    </li>
    <li class="enterprise" v-if="!isInQYGChannel" :class="{'qyg-liWidth': isInQYGChannel}">
      <router-link to="/enterprise" :class="{active: activeTab === '/enterprise'}">
        <icon size="28" :color="activeTab === '/enterprise' ? activeColor : ''">icon_fuli</icon>
        <span>企业福利</span>
      </router-link>
    </li>
    <li class="shop-cart" :class="{'qyg-liWidth': isInQYGChannel}">
      <router-link to="/cart" :class="{active: activeTab === '/cart'}">
        <icon size="31" :color="activeTab === '/cart' ? activeColor : ''" :class="{'cart-center': isInQYGChannel}">tab_gouwuche</icon>
        <mt-badge size="small" color="#c03131" class="badge" v-show="!!cartNum">{{cartNum}}</mt-badge>
        <span>购物车</span>
      </router-link>
    </li>
    <li class="center" :class="{'qyg-liWidth': isInQYGChannel}">
      <router-link to="/center" :class="{active: activeTab === '/center'}">
        <icon size="28" :color="activeTab === '/center' ? activeColor : ''">tab_wode</icon>
        <span>我的</span>
      </router-link>
    </li>
  </ul>
</template>
<script>
  import { Badge } from 'mint-ui'
  import icon from '../components/icon'
  import CONSTANT from '../constant/common'
  import isQiYeGou from '../mixins/qiyegou/qiyegou'

  export default {
    mixins: [isQiYeGou],
    data() {
      return {
        activeColor: 'rgb(192,49,49)'
      }
    },
    computed: {
      activeTab() {
        return this.$route.path
      },
      cartNum() {
        let total = this.$store.state.cart.total
        return total > 99 ? '99+' : total
      }
    },
    components: {
      [Badge.name]: Badge,
      icon,
    },
    mounted() {
      if(!this.$store.state.cart.fetch) {
        this.$store.dispatch('getCartTotal')
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '../../stylesheet/variable';

  .nav-bar {
    position: fixed;
    bottom: 0;
    width:100%;
    display: flex;
    padding: 0;
    margin: 0;
    z-index: 10;
    background: #ffffff;
    list-style: none;
    &::before {
      .setTopLine();
    }
    li {
      width: 25%;
      a {
        width: 100%;
        height: 49px;
        float: left;
        line-height: 28px;
        position: relative;
        color: @steelGrey;
        a::after {
          content: ".";
          height: 0;
          display: block;
          clear: both;
          visibility: hidden;
        }
        .badge {
          position: absolute;
          color: #ffffff !important;
          top: 6px;
          left: calc(~'50% + 2px');
          transform: translateX(0);

        }
        i {
          position: absolute;
          top: 6px;
          left: 50%;
          transform: translateX(-50%);
        }
        .cart-center{
          left: 48%;
        }
        span {
          font-size: 10px;
          line-height: 12px;
          word-break: keep-all;
          color: @steelGrey;
          position: absolute;
          top: 32px;
          left:50%;
          transform: translateX(-50%);
        }
        &.active {
          span {
            color: @reddish;
          }
        }
      }
      &:nth-child(2) a i {
        top: 5px;
      }
      &:nth-child(3) a i {
        top: 4px;
      }
    }
    .qyg-liWidth{
      width: 33.33333333%;
    }
  }
</style>
